<template>
  <div v-if="!model.$disabled" class="radio-list">
    <p v-if="getTitle" class="label">
      <slot>{{ getTitle }}</slot>
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </p>

    <div v-for="(item, index) in values" :key="item.value" class="radio">
      <div class="custom-control custom-radio" :for="sid + index">
        <input
          :id="sid + index"
          type="radio"
          class="custom-control-input"
          tabindex="0"
          :aria-invalid="errorVisible"
          :aria-describedby="errorVisible ? errId : undefined"
          :class="borderValidationClass"
          :checked="item.value === model.$model"
          :disabled="disabled"
          :name="model.$form.testPath ? model.$path : sid + index"
          :value="item.value"
          @change="onInput($event)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />

        <label class="custom-control-label" :for="sid + index" v-html="item.text" />
      </div>
    </div>

    <div v-if="otherLabel">
      <label class="custom-control custom-radio">
        <input
          :id="sid"
          type="radio"
          class="custom-control-input"
          tabindex="0"
          :aria-invalid="errorVisible"
          :aria-describedby="errorVisible ? errId : undefined"
          :class="borderValidationClass"
          :checked="otherIsClicked"
          :disabled="disabled"
          :name="model.$form.testPath ? model.$path : sid"
          @change="onInputOther($event)"
        />

        <label v-show="!otherIsClicked" :for="sid" class="custom-control-label" v-html="otherLabel" />

        <input
          v-show="otherIsClicked"
          ref="input"
          class="form-control"
          :class="{
            borderless: borderless,
            'text-right':
              model.$schema.type == 'number' || model.$schema.type == 'money' || model.$schema.type == 'integer',
            ...borderValidationClass
          }"
          :aria-invalid="errorVisible"
          :aria-describedby="errorVisible ? errId : undefined"
          :name="model.$form.testPath ? model.$path : undefined"
          :placeholder="otherLabel"
          :value="model.$value"
          @input="onInputText"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />
      </label>
    </div>

    <w-error :model="model" />
  </div>
</template>

<script>
import { errorMixin } from '../mixins/errorMixin';
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'WRadioList',
  components: { WError, WTooltip },
  mixins: [errorMixin('radio-list'), modelMixin],
  props: {
    values: {
      type: Array,
      default: () => [] // tablice trzeba zwracać przez funkcję
    },
    otherLabel: String,
    inline: Boolean
    // model: Object
  },

  data() {
    return {
      userOther: false,
      sid: 'rlist' + Math.round(Math.random() * 1000000)
    };
  },
  computed: {
    otherIsClicked() {
      if (!this.model.$value) {
        return this.userOther;
      }
      return !this.values.map(x => x.value).includes(this.model.$value);
    }
  },
  methods: {
    onInput(evt) {
      this.userOther = false;
      if (evt.target.checked) {
        this.model.$value = evt.target.value;
      }
      this.$emit('input');
    },
    onInputOther(evt) {
      this.userOther = true;
      // console.log('onInputOther', this.model.$path);
      this.model.$value = '';
      this.model.$reset();
      setTimeout(() => {
        this.$refs.input.focus();
      }, 10);
    },
    onInputText(evt) {
      this.userOther = true;

      this.model.$value = evt.target.value;
    },
    onBlur(evt) {
      this.model.$hasFocus = false;
      this.$emit('blur', evt);
    },
    onFocus(evt) {
      this.model.$hasFocus = true;

      this.$emit('focus', evt);
    }
  }
};
</script>
